export const GET_STUDENTCERTIFICATES_START = 'studentCertificates/GET_STUDENTCERTIFICATES_START';
export const GET_STUDENTCERTIFICATES_COMPLETED = 'studentCertificates/GET_STUDENTCERTIFICATES_COMPLETED';
export const GET_STUDENTCERTIFICATES_FAILED = 'studentCertificates/GET_STUDENTCERTIFICATES_FAILED';
